import React from 'react';

import { Carousel } from '../../../../../components/Carousel';
import { IHomeCarousel } from '../../../../../models/IHome';
import styles from './OurCoursesCarousel.module.scss';

export const OurCoursesCarousel: React.FC<IHomeCarousel> = ({ children }) => {
  const settings = {
    dots: true,
    variableWidth: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <Carousel className={styles.ourCoursesCarouselContainer} settings={settings}>
      {children}
    </Carousel>
  );
};
